import React from "react";
import { Formik, ErrorMessage } from "formik";
import {
	add,
	wardQuestion,
	photo,
	busStationName,
	parkingCount,
	parkingType,
	otherServiceCount,
	motorCycleCount,
	ward,
	selectedLanguage,
	cancel,
} from "../data/institute";
import ImageUploader from "../components/ImageUploader";
import { Card } from "react-bootstrap";
import FormFooterButtons from "../components/FormFooterButtons";
import { GetUUID } from "../data/helpers/RandomNumGenerator";

const initData = {
	ward: "",
	busStationName: "",
	motorCycleCount: "",
	otherServiceCount: "",
	parkingType: "",
	uniqueIdentifier: GetUUID(),
};

const BusStation = (props) => (
	<div>
		<Formik
			enableReinitialize
			initialValues={props.data ? props.data : initData}
			validate={(values) => {
				const errors = {};
				// if (!values.ward) {
				//     errors.ward = 'Required';
				// }
				// if (!values.riskArea) {
				//     errors.riskArea = 'Required';
				// }
				// if (!values.address) {
				//     errors.address = 'Required';
				// }
				// if (!values.effectFromDisasters) {
				//     errors.effectFromDisasters = 'Required';
				// }
				// else
				// if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
				// 	errors.email = "Invalid email address";
				// }
				return errors;
			}}
			onSubmit={(values, { setSubmitting }) => {
				console.log(values);
				setTimeout(() => {
					props.submit(values);
					setSubmitting(false);
				}, 400);
			}}
		>
			{({
				values,
				touched,
				errors,
				dirty,
				isSubmitting,
				handleChange,
				handleBlur,
				handleSubmit,
				handleReset,
			}) => (
				<>
					<form className="form survey-form" onSubmit={handleSubmit}>
						<Card>
							<Card.Body>
								<div className="form-group row">
									<div className="col-md-6">
										<label className="form-control-label">
											{wardQuestion[selectedLanguage]}
										</label>
										<select
											className="form-control"
											id="ward"
											name="ward"
											onChange={handleChange}
											value={values.ward ? values.ward : "selectOne"}
										>
											<option value="selectOne" disabled>
												कुनै एक छान्नुहोस्
											</option>
											{ward.map((woda) => (
												<option value={woda.value}>
													{woda[selectedLanguage]}
												</option>
											))}
										</select>
										<ErrorMessage
											className="invalid-feedback"
											name="ward"
											component="div"
										/>
									</div>
									<div className="col-md-6">
										<label className="form-control-label">
											{busStationName[selectedLanguage]}
										</label>
										<input
											type="text"
											className="form-control"
											placeholder={busStationName[selectedLanguage]}
											name="busStationName"
											onChange={handleChange}
											value={values.busStationName}
										/>
										<ErrorMessage
											className="invalid-feedback"
											name="busStationName"
											component="div"
										/>
									</div>
								</div>
								<div className="form-group row">
									<div className="col-md-6">
										<label className="form-control-label">
											{parkingType[selectedLanguage]}
										</label>
										<input
											type="text"
											className="form-control"
											placeholder={parkingType[selectedLanguage]}
											name="parkingType"
											onChange={handleChange}
											value={values.parkingType}
										/>
										<ErrorMessage
											className="invalid-feedback"
											name="parkingType"
											component="div"
										/>
									</div>
								</div>
								<hr />
								<h3>{parkingCount[selectedLanguage]}</h3>
								<div className="form-group row">
									<div className="col-md-6">
										<label className="form-control-label">
											{motorCycleCount[selectedLanguage]}
										</label>
										<input
											type="number"
											className="form-control"
											placeholder={motorCycleCount[selectedLanguage]}
											name="motorCycleCount"
											onChange={handleChange}
											value={values.motorCycleCount}
										/>
										<ErrorMessage
											className="invalid-feedback"
											name="motorCycleCount"
											component="div"
										/>
									</div>
									<div className="col-md-6">
										<label className="form-control-label">
											{otherServiceCount[selectedLanguage]}
										</label>
										<input
											type="number"
											className="form-control"
											placeholder={otherServiceCount[selectedLanguage]}
											name="otherServiceCount"
											onChange={handleChange}
											value={values.otherServiceCount}
										/>
										<ErrorMessage
											className="invalid-feedback"
											name="otherServiceCount"
											component="div"
										/>
									</div>
								</div>
								<div className="form-group row">
									<div className="col-md-6">
										<label>{photo[selectedLanguage]}</label>
										<ImageUploader fileListContent={props.fileListContent} />
									</div>
								</div>
								<div className="card-footer text-right">
									<FormFooterButtons />
								</div>
							</Card.Body>
						</Card>
					</form>
				</>
			)}
		</Formik>
	</div>
);

export default BusStation;
